'use es6';

import { dropTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { LAYOUT_SECTION_ROW_APPENDED, LAYOUT_SECTION_COLUMN_INSERTED_AFTER, LAYOUT_SECTION_COLUMN_INSERTED_BEFORE, LAYOUT_SECTION_INSERTED_IN_EMPTY_COLUMN, LAYOUT_SECTION_INSERTED_IN_EMPTY_ROW, LAYOUT_SECTION_ROW_INSERTED_AFTER, LAYOUT_SECTION_ROW_PREPENDED, LAYOUT_SECTION_ROW_INSERTED_BEFORE, GRID_LAYOUTS_ELEMENT_INSERTED_BEFORE, GRID_LAYOUTS_ELEMENT_INSERTED_AFTER, GRID_LAYOUTS_INSERTED_IN_EMPTY_STACK, GRID_LAYOUTS_INSERTED_IN_EMPTY_GRID_LAYOUT, GRID_LAYOUTS_INSERTED_IN_TABLE_CELL, GRID_LAYOUTS_APPENDED_GRID_CELL, GRID_LAYOUTS_INSERTED_AFTER_TABLE_CELL, GRID_LAYOUTS_MOVE_SECTION_AFTER, GRID_LAYOUTS_MOVE_SECTION_BEFORE, GRID_LAYOUTS_WRAP_AND_INSERT_ABOVE_CONTAINER, GRID_LAYOUTS_WRAP_AND_INSERT_BELOW_CONTAINER, GRID_LAYOUTS_WRAP_AND_INSERT_LEFT_OF_CONTAINER, GRID_LAYOUTS_WRAP_AND_INSERT_RIGHT_OF_CONTAINER } from 'ContentEditorUI/redux/actions/actionTypes';
const dropTypesToActionTypes = {
  [dropTypes.APPEND_ROW]: LAYOUT_SECTION_ROW_APPENDED,
  [dropTypes.INSERT_COLUMN_AFTER]: LAYOUT_SECTION_COLUMN_INSERTED_AFTER,
  [dropTypes.INSERT_COLUMN_BEFORE]: LAYOUT_SECTION_COLUMN_INSERTED_BEFORE,
  [dropTypes.INSERT_INTO_EMPTY_COLUMN]: LAYOUT_SECTION_INSERTED_IN_EMPTY_COLUMN,
  [dropTypes.INSERT_INTO_EMPTY_ROW]: LAYOUT_SECTION_INSERTED_IN_EMPTY_ROW,
  [dropTypes.INSERT_ROW_AFTER]: LAYOUT_SECTION_ROW_INSERTED_AFTER,
  [dropTypes.PREPEND_ROW]: LAYOUT_SECTION_ROW_PREPENDED,
  [dropTypes.INSERT_ROW_BEFORE]: LAYOUT_SECTION_ROW_INSERTED_BEFORE,
  [dropTypes.INSERT_ELEMENT_BEFORE]: GRID_LAYOUTS_ELEMENT_INSERTED_BEFORE,
  [dropTypes.INSERT_ELEMENT_AFTER]: GRID_LAYOUTS_ELEMENT_INSERTED_AFTER,
  [dropTypes.INSERT_INTO_EMPTY_STACK]: GRID_LAYOUTS_INSERTED_IN_EMPTY_STACK,
  [dropTypes.INSERT_INTO_EMPTY_GRID_LAYOUT]: GRID_LAYOUTS_INSERTED_IN_EMPTY_GRID_LAYOUT,
  [dropTypes.INSERT_INTO_TABLE_CELL]: GRID_LAYOUTS_INSERTED_IN_TABLE_CELL,
  [dropTypes.APPEND_GRID_CELL]: GRID_LAYOUTS_APPENDED_GRID_CELL,
  [dropTypes.INSERT_AFTER_TABLE_CELL]: GRID_LAYOUTS_INSERTED_AFTER_TABLE_CELL,
  [dropTypes.MOVE_SECTION_BEFORE]: GRID_LAYOUTS_MOVE_SECTION_BEFORE,
  [dropTypes.MOVE_SECTION_AFTER]: GRID_LAYOUTS_MOVE_SECTION_AFTER,
  [dropTypes.WRAP_AND_INSERT_ABOVE_CONTAINER]: GRID_LAYOUTS_WRAP_AND_INSERT_ABOVE_CONTAINER,
  [dropTypes.WRAP_AND_INSERT_BELOW_CONTAINER]: GRID_LAYOUTS_WRAP_AND_INSERT_BELOW_CONTAINER,
  [dropTypes.WRAP_AND_INSERT_LEFT_OF_CONTAINER]: GRID_LAYOUTS_WRAP_AND_INSERT_LEFT_OF_CONTAINER,
  [dropTypes.WRAP_AND_INSERT_RIGHT_OF_CONTAINER]: GRID_LAYOUTS_WRAP_AND_INSERT_RIGHT_OF_CONTAINER
};
const getActionTypeFromDropType = dropType => {
  const actionType = dropTypesToActionTypes[dropType];
  if (!actionType) {
    console.log(`Missing add to layout action type for drop type ${dropType}`);
  }
  return actionType;
};
export const createAddToLayoutAction = dropTarget => {
  const dropTargetType = dropTarget.type;
  const addToLayoutActionPayload = Object.assign({
    nextColumnId: dropTarget.nextColumnId
  }, dropTarget);
  delete addToLayoutActionPayload.type;
  const addToLayoutAction = {
    payload: addToLayoutActionPayload
  };
  if ([dropTypes.APPEND_ROW, dropTypes.PREPEND_ROW, dropTypes.INSERT_COLUMN_AFTER, dropTypes.INSERT_COLUMN_BEFORE, dropTypes.INSERT_INTO_EMPTY_COLUMN].includes(dropTargetType)) {
    addToLayoutAction.type = getActionTypeFromDropType(dropTargetType);
    addToLayoutAction.payload.columnId = dropTarget.id;
    delete addToLayoutAction.payload.id;
  } else if (dropTargetType === dropTypes.INSERT_ROW_BEFORE || dropTargetType === dropTypes.INSERT_ROW_AFTER) {
    if (dropTarget.isColumn) {
      // Moving row to a column, causing the cell to "split"
      const isBefore = dropTargetType === dropTypes.INSERT_ROW_BEFORE;
      addToLayoutAction.type = isBefore ? LAYOUT_SECTION_ROW_PREPENDED : LAYOUT_SECTION_ROW_APPENDED;
      addToLayoutAction.payload.columnId = dropTarget.id;
    } else {
      // Moving row -> row
      addToLayoutAction.type = getActionTypeFromDropType(dropTargetType);
      addToLayoutAction.payload.rowId = dropTarget.id;
    }
  } else if (dropTargetType === dropTypes.INSERT_INTO_EMPTY_ROW) {
    addToLayoutAction.type = getActionTypeFromDropType(dropTargetType);
    addToLayoutAction.payload.rowId = dropTarget.id;
    delete addToLayoutAction.payload.id;
  } else if ([dropTypes.INSERT_ELEMENT_BEFORE, dropTypes.INSERT_ELEMENT_AFTER, dropTypes.INSERT_INTO_EMPTY_STACK, dropTypes.INSERT_INTO_EMPTY_GRID_LAYOUT, dropTypes.INSERT_INTO_TABLE_CELL, dropTypes.APPEND_GRID_CELL, dropTypes.INSERT_AFTER_TABLE_CELL, dropTypes.MOVE_SECTION_BEFORE, dropTypes.MOVE_SECTION_AFTER, dropTypes.WRAP_AND_INSERT_ABOVE_CONTAINER, dropTypes.WRAP_AND_INSERT_BELOW_CONTAINER, dropTypes.WRAP_AND_INSERT_LEFT_OF_CONTAINER, dropTypes.WRAP_AND_INSERT_RIGHT_OF_CONTAINER].includes(dropTargetType)) {
    addToLayoutAction.type = getActionTypeFromDropType(dropTargetType);
  }
  return addToLayoutAction;
};